import {ColourPickerService} from "./service/ColourPickerService";
import {TfColourPicker, tfColourPickerDialog} from "./dialog/ColourPickerDialogComponent";
import {ColourPickerComponent, tfColourPicker} from "./component/ColourPickerComponent";

export default angular.module("tfApp.components.colour-picker", [])
                      .component(TfColourPicker, tfColourPickerDialog())
                      .component(ColourPickerComponent, tfColourPicker())
                      .service(ColourPickerService.id, ColourPickerService)
                      .name;
